import { render, staticRenderFns } from "./ChapterBanner.vue?vue&type=template&id=c8761a58&scoped=true&"
import script from "./ChapterBanner.vue?vue&type=script&lang=js&"
export * from "./ChapterBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChapterBanner.vue?vue&type=style&index=0&id=c8761a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8761a58",
  null
  
)

export default component.exports